import React, { useState } from "react";
import { Checkbox, Box, Flex, Text, UnstyledButton } from "@mantine/core";
import { IconCaretRightFilled, IconCaretDownFilled } from "@tabler/icons-react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import {
  defaultEmailStreams,
  emailStreamLabels,
  frenchEmailStreamLabels,
} from "@components/Email/helpers";

const iconProps = {
  size: 20,
  color: "var(--mantine-color-dark-3)",
  fill: "var(--mantine-color-dark-3)",
  style: {
    color: "var(--mantine-color-dark-3)",
  },
};

export default function MicrositeUserEmailStreams({
  onChange,
  streams = defaultEmailStreams.map((m) => ({ ...m, value: true })),
  user,
  language = "en",
}) {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();
  function onStreamChange(streamId) {
    const newStreams = [...streams];
    const newStream = newStreams.find((f) => f.id === streamId);
    if (!newStream) return;
    newStream.value = !newStream.value;
    onChange(newStreams);

    if (user) {
      const req = {
        user_email_stream_id: streamId,
        user_location_id: user.user_location_id,
        user_organization_id: user.user_organization_id,
      };

      axios.post(
        user.user_location_id
          ? `/user-locations/${user.user_location_id}/toggle-email-stream/`
          : `/user-organizations/${user.user_organization_id}/toggle-email-stream/`,
        req
      );
    }
  }

  return (
    <>
      <UnstyledButton onClick={() => setOpen(!isOpen)}>
        <Flex align="center" gap="xs">
          {isOpen ? (
            <IconCaretDownFilled {...iconProps} />
          ) : (
            <IconCaretRightFilled {...iconProps} />
          )}
          <Text c="dimmed" fw={600}>
            {t("mixer:email_preferences")}
          </Text>
        </Flex>
      </UnstyledButton>
      {isOpen && (
        <Box mt="sm">
          {streams.map((stream, i) => (
            <Checkbox
              mb="sm"
              key={i}
              label={t(stream.translation_key) || stream.label}
              // label={
              //   language === "en"
              //     ? emailStreamLabels[stream.variety] || stream.label
              //     : frenchEmailStreamLabels[stream.variety] || stream.label
              // }
              checked={stream.value}
              onChange={() => onStreamChange(stream.id)}
            />
          ))}
        </Box>
      )}
    </>
  );
}
